import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class TimeFormatService {
  constructor(private authService: AuthService) {}

  isReady(): boolean {
    // Check if we have the data we actually need for formatting
    // We need either profile loaded (for user preference) or tenant loaded (for fallback)
    return this.authService.profile != null || this.authService.tenant != null;
  }

  private get use24HourTime(): boolean {
    // Use user preference if available, otherwise fallback to false (12-hour)
    return this.authService.profile?.use24HourTime ?? false;
  }

  get timeFormat(): string {
    return this.use24HourTime ? 'HH:mm' : 'h:mm a';
  }

  get dateTimeFormat(): string {
    return this.use24HourTime ? 'MMM D yyyy HH:mm' : 'MMM D yyyy h:mm a';
  }

  get shortDateTimeFormat(): string {
    return this.use24HourTime ? 'M/D/yyyy HH:mm' : 'M/D/yyyy h:mm a';
  }

  getFormat(formatType: 'time' | 'dateTime' | 'shortDateTime' | 'date'): string {
    switch (formatType) {
      case 'time':
        return this.timeFormat;
      case 'dateTime':
        return this.dateTimeFormat;
      case 'shortDateTime':
        return this.shortDateTimeFormat;
      case 'date':
        return 'MMM D yyyy';
      default:
        return this.dateTimeFormat;
    }
  }
}
